import {Controller} from "stimulus"
import Splide from "@splidejs/splide"

export default class extends Controller {

    static targets = [
    ]

    initialize() {

        new Splide( '.splide-images' ).mount();
        new Splide( '.splide-plans' ).mount();

    }

}
